import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const wrap = { maxWidth: 800, margin: '0 auto', padding: '40px 20px 60px', color: 'var(--text)' };
const h1 = { fontSize: 28, fontWeight: 800, marginBottom: 8 };
const h2 = { fontSize: 18, fontWeight: 700, margin: '28px 0 8px' };
const p = { fontSize: 15, lineHeight: 1.7, color: 'var(--muted)', margin: '0 0 12px' };

export default function AboutPage() {
  return (
    <div style={wrap}>
      <Helmet>
        <title>About Us — Algovex</title>
        <meta name="description" content="Algovex is a visual, no-code platform for building and backtesting trading strategies." />
      </Helmet>
      <h1 style={h1}>About Algovex</h1>
      <p style={p}>
        Algovex is a visual, no-code platform for building and backtesting trading strategies.
        We believe that testing a trading idea rigorously shouldn’t require writing code — so we
        built a drag-and-drop strategy builder backed by a real event-driven backtesting engine.
      </p>

      <h2 style={h2}>What you can do</h2>
      <p style={p}>
        Design a strategy by connecting indicators, conditions, and rules on a visual canvas, then
        backtest it against historical stock, forex, and crypto data. Analyze performance with
        professional metrics, run walk-forward analysis to guard against overfitting, paper-trade
        strategies forward on live market data, and get AI help refining your ideas.
      </p>

      <h2 style={h2}>Our approach</h2>
      <p style={p}>
        Good backtesting is honest backtesting. Algovex is built to surface the things that
        actually matter — drawdowns, robustness across regimes, and the gap between an in-sample
        result and live performance — rather than just a pretty equity curve.
      </p>

      <h2 style={h2}>Important disclaimer</h2>
      <p style={p}>
        Algovex is a research and educational tool. It does not provide financial, investment, or
        trading advice, and nothing on this platform is a recommendation to buy or sell any
        security. Backtested and simulated results are hypothetical and do not guarantee future
        performance. Always do your own research and consider consulting a licensed professional.
      </p>

      <p style={{ ...p, marginTop: 24 }}>
        Questions? <Link to="/contact" style={{ color: 'var(--teal)' }}>Get in touch</Link>.
      </p>
    </div>
  );
}
